import { createSelector } from 'reselect';
import { getPlayersSelector } from './selector/get-players.selector';
import { PlayerView } from './view/player.view';

export const PlayersPresenter = createSelector(
  [getPlayersSelector],
  (players): PlayerView[] => {
    return players
      .map(
        (player) =>
          ({
            id: player.id,
            name: player.name,
            latitude: player.location.latitude,
            longitude: player.location.longitude,
          }) satisfies PlayerView as PlayerView,
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  },
);
